import { useMutation, useQueryClient } from 'react-query'
import luminaireAPI from '../service/luminaireAPI'
import { Luminaire } from '../types/luminaire.types'

export interface UpdateLuminaireTagsArgs {
  luminaire: Luminaire
  tags: string[]
}

const normalizeClient = (tags: string[]): string[] => {
  const seen = new Set<string>()
  const out: string[] = []
  for (const raw of tags) {
    const t = raw.trim().toLowerCase()
    if (!t || seen.has(t)) continue
    seen.add(t)
    out.push(t)
  }
  return out
}

export const useUpdateLuminaireTags = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: async ({ luminaire, tags }: UpdateLuminaireTagsArgs) => {
      const fresh = await luminaireAPI.getLuminaireById(luminaire.lum_id)
      const next: Luminaire = {
        ...fresh,
        lum_tags: normalizeClient(tags),
      }
      return luminaireAPI.updateLuminaire(luminaire.lum_id, next)
    },
    onSuccess: () => {
      queryClient.invalidateQueries('luminaires')
      queryClient.invalidateQueries(['luminaires-fleet'])
    },
  })

  return mutation
}

export default useUpdateLuminaireTags
